<!-- 商城商品列表集合-->
<template>
  <div class="grid-container">
    <div v-for="(item, index) in DataList" :key="index" class="grid-item">
      <div @click="goDetail(item)">
        <div class="card-item">
          <div class="image-wrapper">
            <van-image
              lazy-load
              fit="cover"
              class="product-image"
              :src="item.coverImage"
            />
            <span
              v-if="isNewProduct(item)"
              class="new-badge"
            >新品</span>
          </div>
          <div class="card-body">
            <span class="texttitle">
              <van-tag class="tag" v-if="getTitleTag(item)" :color="getTitleTag(item).colorCode">{{ getTitleTag(item).name }}</van-tag>
              {{ item.name }} 
            </span>
            <div class="tags">
              <span class="contextTag" v-for="(val, index) in getTagList(item)" :key="index">{{ val.name }}
              </span>
            </div>
            <!-- 根据后端返回的 isShowPrice 决定是否显示价格（次数卡不显示） -->
            <div class="textFoot" v-if="item.isShowPrice !== false">
              <div class="price-main-row">
                <span class="price-value">{{ item.showPrice }}</span>
                <span class="price-unit">{{ item.cardPointTypeUnit || '点' }}</span>
                <template v-if="showItemPriceCompare(item)">
                  <span class="market-price">参考价{{ item.marketPrice }}{{ item.cardPointTypeUnit || '点' }}</span>
                  <span class="save-amount">立省{{ formatSaveAmount(item.saveAmount) }}{{ item.cardPointTypeUnit || '点' }}</span>
                </template>
              </div>
            </div>
            <div class="textFoot" v-else></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoodsListCom",
  props: {
    DataList: {
      type: Array,
    },
    activityId: {
      type: String,
      default: '',
    },
    hotType: {
      type: String,
      default: 'B',
    },
    /** 活动特性：0 普通 1 价格保护（仅活动商品列表传入） */
    activityFeatureType: {
      type: String,
      default: '',
    },
  },
  components: {},
  methods: {
    showItemPriceCompare(item) {
      return String(this.activityFeatureType) === '1'
        && item
        && this.hasJdSkuCode(item.jdSkuCode)
        && item.marketPrice != null
        && item.saveAmount != null
        && Number(item.saveAmount) > 0
    },
    hasJdSkuCode(code) {
      return !!(code && String(code).trim())
    },
    formatSaveAmount(val) {
      if (val == null || val === '') return '0'
      const num = Number(val)
      if (Number.isNaN(num)) return val
      return Number.isInteger(num) ? String(num) : num.toFixed(2).replace(/\.?0+$/, '')
    },
    goDetail(val) {
      const id = val && val.id ? String(val.id) : '';
      const isDsProduct = /^DS/i.test(id);
      const activityQuery = this.activityId
        ? {
          activityId: this.activityId,
          hotType: this.hotType,
          activityFeatureType: this.activityFeatureType || '0',
        }
        : {};
      // 蛋叔 V2：ID 以 DS 开头时，走独立 V2 详情页
      if (isDsProduct) {
        this.$router.push({
          path: `/DetailsDsV2/${encodeURIComponent(id)}`,
        });
        return;
      }
      if(val.type == '7'){
        //跳转直充商品详情
        this.$router.push({
          path: "/DetailsRecharge",
          query: {
            id: val.id,
            specId: val.specId,
            brandId: val.brandId,
          }
        });
      }else if(val.type == '8'){
        //跳转蛋叔卡券商品详情
        this.$router.push({
          path: "/DetailsDsCardCoupons",
          query: {
            id: val.id,
            specId: val.specId,
            brandId: val.brandId,
          }
        });
      }else if(val.type == '13'){
        this.$router.push({
          path: "/DetailsRyCard",
          query: {
            id: val.id,
            specId: val.specId,
            brandId: val.brandId,
          }
        });
      }else{
        this.$router.push({
          path: "/Details",
          query: {
            id: val.id,
            specId: val.specId,
            brandId: val.brandId,
            ...activityQuery,
          }
        });
      }
    },
    getTitleTag(item) {
      let Tag = undefined
      if (item.labelList) {
        item.labelList.forEach(element => {
          if (element.smallLabelType == '1') {
            Tag = element
          }
        });
      }
      return Tag
    },
    getTagList(item) {
      let Tag = []
      if (item.labelList) {
        item.labelList.forEach(element => {
          if (element.smallLabelType !== '1') {
            Tag.push(element)
          }
        });
      }
      return Tag
    },
    // 判断商品是否为新品（创建时间在15天内）
    isNewProduct(item) {
      if (!item.createdAt) return false
      const createDate = new Date(item.createdAt)
      const now = new Date()
      const diffDays = (now - createDate) / (1000 * 60 * 60 * 24)
      return diffDays <= 15
    }

  },

  mounted() {
  },
  computed: {},
  watch: {},
};
</script>

<style lang='scss' scoped>
.grid-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  padding: 0 0.5rem;
  gap: 0.5rem;
  background-color: transparent;

  .grid-item {
    flex-basis: calc(50% - 0.25rem);
    width: calc(50% - 0.25rem);
    align-self: flex-start;

    .card-item {
      background-color: #fff;
      border-radius: 0.6rem;
      overflow: hidden;
      box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
      display: flex;
      flex-direction: column;
    }
  }
}

.image-wrapper {
  position: relative;
  width: 100%;
  overflow: hidden;
  background-color: #f5f5f5;

  // 固定 1:1 占位，与行业商城首页商品卡片一致
  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
}

.product-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: block;

  :deep(.van-image__img) {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.6rem 0.6rem 0 0;
  }

  :deep(.van-image__loading),
  :deep(.van-image__error) {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
  }
}

.card-body {
  display: flex;
  flex-direction: column;
  padding: 0.45rem 0.55rem 0.5rem;
}

.texttitle {
  font-size: 0.8rem;
  font-weight: 500;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  min-height: 2.1rem;
  line-height: 1.35;
  letter-spacing: 0.01em;
}

.tags {
  margin-top: 0.25rem;
  min-height: 1.1rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.2rem;

  .tag {
    margin-right: 0;
  }
}

.textFoot {
  margin-top: 0.3rem;
  width: 100%;
  min-height: 1.4rem;
}

.price-main-row {
  display: flex;
  flex-wrap: nowrap;
  align-items: baseline;
  width: 100%;
  line-height: 1.2;
  overflow: hidden;
  gap: 0.2rem;

  .price-value {
    font-size: 1.05rem;
    color: #d23b2e;
    font-weight: 700;
    letter-spacing: -0.02em;
    flex-shrink: 0;
  }

  .price-unit {
    font-size: 0.65rem;
    color: #d23b2e;
    font-weight: 400;
    flex-shrink: 0;
  }

  .market-price {
    flex-shrink: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-left: 0.1rem;
    font-size: 0.58rem;
    color: #999;
    text-decoration: line-through;
  }

  .save-amount {
    flex-shrink: 0;
    margin-left: 0.15rem;
    padding: 0.05rem 0.25rem;
    font-size: 0.58rem;
    color: #ff7d00;
    font-weight: 600;
    white-space: nowrap;
    border-radius: 0.15rem;
    background: rgba(255, 125, 0, 0.1);
  }
}

.contextTag {
  display: inline-flex;
  font-weight: 500;
  align-items: center;
  padding: 0.08rem 0.35rem;
  color: #ff7d00;
  border: 1px solid #ffe0b2;
  background-color: #fff8f0;
  font-size: 0.6rem;
  line-height: 1.1;
  border-radius: 0.2rem;
}

.van-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.08rem 0.35rem;
  color: #fff;
  font-size: 0.6rem;
  line-height: 1.1;
  border-radius: 0.2rem;
  margin-right: 0.1rem;
  vertical-align: middle;
}

.new-badge {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  min-width: 2.7rem;
  padding: 0.18rem 0.42rem;
  background: #d81e06;
  color: #fff;
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.2;
  text-align: center;
  letter-spacing: 0.04em;
  border-radius: 0.6rem 0 0.4rem 0;
  pointer-events: none;
  box-shadow: 0 1px 4px rgba(216, 30, 6, 0.28);
}
</style>